import type { BackgroundProgress } from 'core/http/project/background/background-task.service';
import { createAction, props } from '@ngrx/store';

export const saveReadyProgress = createAction('[Ready Progress Store] Save Ready Progress', props<{ progress: BackgroundProgress }>());
